import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router';
import { ToastContainer } from 'react-toastify';

import { AuthProvider } from '@/providers/auth/auth-provider';
import { HttpProvider } from '@/providers/HttpProvider/http-provider';
import { store } from '@/redux/store';
import ThemeProvider from '@/styles/theme';

import Router from './routes';

//import '@fontsource/barlow/100.css';
//import '@fontsource/barlow/200.css';
//import '@fontsource/barlow/300.css';
//import '@fontsource/barlow/400.css';
//import '@fontsource/barlow/500.css';
//import '@fontsource/barlow/600.css';
//import '@fontsource/barlow/700.css';
//import '@fontsource/barlow/800.css';
//import '@fontsource/barlow/900.css';
import './index.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} />
      <AuthProvider>
        <HttpProvider>
          <Provider store={store}>
            <ThemeProvider>
              <Router />
            </ThemeProvider>
          </Provider>
        </HttpProvider>
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);
